import { Button } from '@/components/ui';
import { WelcomeFireworks } from '@/pages/professional/components/WelcomeFireworks';
import { ArrowRight } from 'lucide-react';
import { useNavigate, useOutletContext } from 'react-router-dom';

const PLUMAA_LOGO_URL =
	'https://res.cloudinary.com/dd5pbp2tb/image/upload/v1770986601/Plumaa_H_psjyrs.png';

function professionalDisplayName(pro: Professionals.Professional) {
	return [pro.name_prefix, pro.first_name, pro.last_name]
		.filter(Boolean)
		.join(' ');
}

type ProfessionalLayoutContext = {
	data: Professionals.Professional | undefined;
	isLoading: boolean;
};

const WelcomeProfessional = () => {
	const navigate = useNavigate();

	const { data: professionalData, isLoading } =
		useOutletContext<ProfessionalLayoutContext>();

	if (isLoading || !professionalData) return null;

	const name = professionalDisplayName(professionalData);
	const isAuthorized = Boolean(professionalData.authorized);

	return (
		<section className="relative flex min-h-full w-full flex-col items-center justify-center bg-white px-4 py-16 md:py-24">
			{isAuthorized && <WelcomeFireworks />}
			<div className="flex w-full max-w-2xl flex-col items-center justify-center space-y-10 md:space-y-12">
				<img
					src={PLUMAA_LOGO_URL}
					alt="Plumaa"
					className="h-20 w-auto object-contain md:h-24"
					draggable={false}
				/>

				<div className="flex flex-wrap items-end justify-center gap-x-1 gap-y-1 text-center">
					<h1 className="text-lg font-semibold leading-snug text-zinc-800 md:text-2xl">
						Olá
					</h1>
					<div className="flex items-end">
						<span
							className={`text-lg font-bold leading-snug md:text-2xl ${
								isAuthorized
									? 'text-brand-orange'
									: 'text-brand-pink'
							}`}
						>
							{name}
						</span>
						<span className="text-lg font-semibold leading-snug text-zinc-800 md:text-2xl">
							,
						</span>
					</div>
					{isAuthorized ? (
						<h1 className="text-lg font-semibold leading-snug text-zinc-800 md:text-2xl">
							bem-vindo à Plumaa!
						</h1>
					) : (
						<h1 className="text-lg font-semibold leading-snug text-zinc-800 md:text-2xl">
							obrigado pelo cadastro.
						</h1>
					)}
				</div>

				<div className="max-w-lg space-y-6 text-center text-base font-medium leading-relaxed text-stone-500 md:text-lg">
					{isAuthorized ? (
						<div className="flex w-full flex-col items-center gap-6">
							<p>
								Sua conta já está liberada. Pode usar o painel
								normalmente.
							</p>
							<Button
								type="button"
								text="Ir para o início"
								onClick={() => navigate('/profissional/home')}
								endIcon={
									<ArrowRight className="size-5 stroke-[2.5] text-white" />
								}
								className="rounded-full bg-brand-orange px-8 py-2.5 text-sm font-bold text-white shadow-md shadow-brand-orange/30 hover:bg-brand-orange/90"
							/>
						</div>
					) : (
						<p>
							Aguardando a liberação da equipe. Em geral
							respondemos em poucos dias — você acessa por aqui
							assim que for autorizado.
						</p>
					)}
				</div>
			</div>
		</section>
	);
};

export { WelcomeProfessional };
